import { Tabs } from 'antd';
import React from 'react';
import { withRouter } from 'react-router-dom';
import infoSvg from '../../../assets/info.svg';

const { TabPane } = Tabs;

const UserTabs = ({ children }) => {
  const infoTitle = (
    <div>
      <img src={infoSvg} alt="info-icon" />
      <span className="card-title">Information</span>
    </div>
  );

  return (
    <div className="card-container">
      <Tabs type="card" activeKey="INFORMATION">
        <TabPane tab={infoTitle} key="INFORMATION">
          {children}
        </TabPane>
      </Tabs>
    </div>
  );
};

export default withRouter(UserTabs);
